import React, { useState, useEffect, useContext } from 'react';
import MaterialTable from 'material-table';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import GenericDialogBox from '../../components/GenericDialogBox';
import InfoBox from '../../components/InfoBox';
import DataService from "../../services/data.service";
import { useTranslation } from "react-i18next";
import PermissionContext from '../../contexts/PermissionContext';
import currency from 'currency.js'

const currFormat = { decimal: ',', symbol: '', separator: '.' }

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(18),
        maxWidth: 900,
        margin: 'auto',
        overflow: 'hidden',
        backgroundColor: 'white'
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {

        margin: theme.spacing(3, 2, 2),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));




const DetailForm = (props) => {

    const getData = props.getData;
    const { payrollId, setPayRollId, productData, setProductData, permission } = props

    const { userHasPermission } = useContext(PermissionContext)

    // console.log("UHP",userHasPermission)

    let hasPerm = userHasPermission(permission, 'can_list')
    let hasAddPerm = userHasPermission(permission, 'can_post')
    let hasEditPerm = userHasPermission(permission, 'can_patch')
    let hasGetPerm = userHasPermission(permission, 'can_get')
    let hasDeletePerm = userHasPermission(permission, 'can_delete')
    // for detail form
    let hasDeleteDetailPerm = userHasPermission(`${permission}-detail`, 'can_delete')


    const [qtty, setQtty] = useState(1)
    const [price, setPrice] = useState(0.00)
    const openNoticeBox = props.openNoticeBox
    const { t } = useTranslation();

    const [productValue, setProductValue] = React.useState("-");
    const [productInputValue, setProductInputValue] = React.useState('');

    //autofocus thingy
    // const nextfield = document.querySelector(
    // 	`input[id=product]`
    // );
    // console.log("next", nextfield)
    // // If found, focus the next field
    // if (nextfield !== null) {
    // 	nextfield.focus();
    // }
    const moveToFirst = () => {
        //autofocus thingy place at the first field after adding
        const nextfield = document.querySelector(
            `input[id=product]`
        );
        // If found, focus the next field
        if (nextfield !== null) {
            nextfield.focus();
        }
    }

    const addData = (values) => {
        DataService.create(`${endpoint}/`, values)
            .then(response => {
                // openNoticeBox("Notice", "PayRoll created successfully")
                // setPayRollId(response.data.id)
                // setData(emptyData)
                getData(payrollId)
            })
            .catch(e => {
                openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText} - ${e.response.data.detail}`)

            });

    }

    const AddDetail = (event) => {
        event.preventDefault();
        if (typeof productValue === 'undefined') {
            openNoticeBox("Error", t("should_pick_a_product"))
            return false
        }
        let values = {
            'payroll_id': payrollId,
            'product_id': productValue.id,
            'qtty': qtty,
            'price': price,
        }
        //  console.log(values)
        addData(values)
        moveToFirst()
    }

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <Typography variant="h6" component="h6">
                    Detalle de Nomina
                </Typography>
            </Grid>

        </Grid>
    )
}


const endpoint = `payroll-detail`
const payrollEndpoint = `payroll`


const DetailTable = (props) => {
    const { t } = useTranslation();

    const { payrollId, setPayRollId, getPayRollData, permission } = props

    const { userHasPermission } = useContext(PermissionContext)

    // console.log("UHP",userHasPermission)

    let hasPerm = userHasPermission(permission, 'can_list')
    let hasAddPerm = userHasPermission(permission, 'can_post')
    let hasEditPerm = userHasPermission(permission, 'can_patch')
    let hasGetPerm = userHasPermission(permission, 'can_get')
    let hasDeletePerm = userHasPermission(permission, 'can_delete')
    // for detail form
    let hasDeleteDetailPerm = userHasPermission(`${permission}-detail`, 'can_delete')



    const [allowanceTotal, setAllowanceTotal] = useState("0.00")

    const [deductionTotal, setDeductionTotal] = useState("0.00")

    const [detailTotal, setDetailTotal] = useState("0.00")
    useEffect(() => {
        // console.log(allowanceTotal,deductionTotal,detailTaxTotal)

        setDetailTotal(allowanceTotal + deductionTotal)
    }, [deductionTotal, allowanceTotal]);

    const [showForm, setShowForm] = useState(false);

    const classes = useStyles();

    // INFO NOTIFICATION VARS
    const [infoOpen, setInfoOpen] = useState(false);
    const [infoTitle, setInfoTitle] = useState('');
    const [infoBody, setInfoBody] = useState('');
    //***********************

    //Dialog Vars
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogueTitle, setDialogueTitle] = useState('');
    const [dialogueBody, setDialogueBody] = useState('');
    //**********

    // DIALOG FUNCTIONS
    const handleDialogOk = () => {
        setDialogOpen(false)
    };

    const handleDialogClose = () => {
        setDialogOpen(false)
    };

    const openDialogBox = (title, body) => {
        setDialogueTitle(title)
        setDialogueBody(body)
        setDialogOpen(true)
    };
    //*******************

    // Notification INFO functions
    const openNoticeBox = (title, body) => {
        setInfoTitle(title)
        setInfoBody(body)
        setInfoOpen(true)
    };

    const handleInfoClose = () => {
        setInfoOpen(false)
    };
    // *****************


    const [detailData, setDetailData] = useState([]);
    useEffect(() => {
        getData(payrollId)
    }, []);

    const getData = (id) => {
        DataService.get(id, endpoint)
            .then(response => {
                console.log("get data", response.data)
                setDetailData(response.data)
                var sumallowance = 0;
                var sumdeduction = 0;
                response.data.forEach(function (record) {
                    sumallowance += record.allowance;
                    sumdeduction += record.deduction;
                });
                setAllowanceTotal(sumallowance)
                setDeductionTotal(sumdeduction)
                getPayRollData(payrollId)
            })
            .catch(e => {
                if (e.response.status !== '404') {
                    openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText}`)
                    // setData(emptyData)
                } else {
                    // setData(emptyData)
                    console.log("")
                }

            });
    }

    const deleteDetail = (id) => {
        var dataDelete = { 'id': id };
        DataService.delete(endpoint, dataDelete)
            .then(response => {
                // openNoticeBox("Notice", "PayRoll deleted successfully")
                getData(payrollId)
            })
            .catch(e => {
                openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText}`)
            });
    }


    return (
        <Grid container spacing={2}>
            <GenericDialogBox
                opn={dialogOpen}
                handleDialogOk={handleDialogOk}
                handleDialogClose={handleDialogClose}
                title={dialogueTitle}
                body={dialogueBody} />
            <InfoBox
                opn={infoOpen}
                handleDialogClose={handleInfoClose}
                title={infoTitle}
                body={infoBody} />

            <MaterialTable
                title="Detail"
                columns={[
                    { title: 'ID', field: 'id', width: "5%" },
                    { title: t("payroll_form_detail_employee"), field: 'employee.name', width: "70%" },
                    { title: t("payroll_form_detail_concept"), field: 'concept.name', width: "70%" },
                    { title: t("payroll_form_detail_description"), field: 'description', width: "5%" },
                    { title: t("payroll_form_detail_allowance"), field: 'allowance', width: "5%", render: rowData => rowData.allowance.toFixed(2) },
                    { title: t("payroll_form_detail_deduction"), field: 'deduction', width: "5%", render: rowData => rowData.deduction.toFixed(2) }
                ]}
                data={detailData}
                actions={[
                    rowData => ({
                        icon: 'delete',
                        tooltip: t("detail_delete_record_tip"),
                        onClick: (event, rowData) => deleteDetail(rowData.id),
                        disabled: !hasDeletePerm
                    }),
                ]}
                options={{
                    actionsColumnIndex: -1,
                    search: false,
                    paging: false,
                    tableLayout: 'auto'

                }}
                components={{
                    Toolbar: props => (
                        <div style={{ backgroundColor: '#e8eaf5' }}>
                            <DetailForm
                                payrollId={payrollId}
                                openNoticeBox={openNoticeBox}
                                getData={getData}
                                permission={permission}
                            />
                        </div>
                    )
                }}
            />
            <div style={{ align: 'right', width: '500px', textAlignLast: 'right' }}>
                <Typography variant="h6" component="h6">
                    Asignaciones: {currency(allowanceTotal, currFormat).format()}
                </Typography>
                <Typography variant="h6" component="h6">
                    Deducciones  {currency(deductionTotal, currFormat).format()}
                </Typography>
                <Typography variant="h5" component="h5">
                    Total: {currency(detailTotal, currFormat).format()}
                </Typography>
            </div>
        </Grid>
    )
}

export default DetailTable;